// Copyright 2024 IOTA Stiftung.
// SPDX-License-Identifier: Apache-2.0.
export * from "./documentManagementRestClient.js";
